import BaseObject from '../../../base/base_object';
import ServiceFactory from '../../service_factory';

export function createGameFlowCancelResponse(message) {
    return {
        reason: 'OPEN_GAME_FLOW_CANCELED',
        message: message
    }
}

export function cancelGameFlow(message) {
    return Promise.reject(createGameFlowCancelResponse(message));
}

export function isCancelGameFlowResponse(err) {
    if (!err) {
        return true;
    }

    return err.reason === 'OPEN_GAME_FLOW_CANCELED';
}

export default abstract class GameStepBase extends BaseObject {
	static CLASS = 'GameStepBase';
	
	protected serviceFactory: ServiceFactory;

    init(params) {
        super.init(params);
        if(!params.serviceFactory) {
            this.throwArgumentExpected('31', 'init', 'serviceFactory');
        }
        this.serviceFactory = params.serviceFactory;
    }

    run(gameOptions: {[key: string]: any}) {
        this.throwNotImplemented('37', 'run');
    }
}